import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './imgSlide.css'

import "../../utils/colors.css"

import React from "react";
 
const ImageSlider = ({ images }) => {
    const settings = {
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 2000,
    };
    return (
        <>
            <div className="tag" style={{
                backgroundColor: "black",
                color: 'white',
                padding: '1rem',
                textAlign: 'center',                
                marginBottom: '2rem'
            }}>
                <h1 style={{ fontWeight: 'bold' }}>Cabs Available for Tour & Travels</h1>
                <p style={{ color: 'white'}}>
                Feel your happiness in the journey..... “𝙰𝚕𝚕 𝚓𝚘𝚞𝚛𝚗𝚎𝚢𝚜 𝚑𝚊𝚟𝚎 𝚜𝚎𝚌𝚛𝚎𝚝 𝚍𝚎𝚜𝚝𝚒𝚗𝚊𝚝𝚒𝚘𝚗𝚜 𝚘𝚏 𝚠𝚑𝚒𝚌𝚑 𝚝𝚑𝚎 𝚝𝚛𝚊𝚟𝚎𝚕𝚎𝚛 𝚒𝚜 𝚞𝚗𝚊𝚠𝚊𝚛𝚎.”
                </p>
            </div>
            
            
            <div className="imgslider" style={{textAlign: 'center',width: '75%',margin: '0 auto'}} >
                <Slider {...settings}>
                    {images.map((item) => (
                        <div className='img-slide' key={item.id}>
                            <img 
                                src={item.src}
                                alt={item.alt}                                
                            />
                        </div>
                    ))}
                </Slider>
            </div>
            
        </>
    );
};
export default ImageSlider;